<template>
  <div class="hidden lg:block absolute top-0 left-0 w-full h-full">
    <div class="relative h-full w-full flex items-center justify-center">
      <NuxtLink :to="{name: 'works', query: {q: 'motion-graphics'}}" class="absolute top-1/2 left-1/2 -rotate-[20deg] -translate-y-[100%] -translate-x-[200%] uppercase rounded-full" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
        <div class="relative text-black text-[1.5vw] w-fit px-6 py-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-yellow -scale-x-[1.3] scale-y-[1.1]" viewBox="0 0 206 62" fill="none">
          <g clip-path="url(#clip0_3430_9566)">
          <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
          </g>
          <defs>
          <clipPath id="clip0_3430_9566">
          <rect width="206" height="62" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          <div class="relative z-1">Motion Graphic</div>
        </div>
      </NuxtLink>

      <NuxtLink :to="{name: 'works', query: {q: '3d-animation'}}" class="absolute z-10 top-1/2 left-1/2 rotate-[20deg] -translate-y-[500%] -translate-x-[50%] uppercase rounded-full" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
        <div class="relative text-white text-[1.5vw] w-fit px-6 py-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-orange scale-x-[1.3] -scale-y-[1.1]" viewBox="0 0 206 62" fill="none">
          <g clip-path="url(#clip0_3430_9566)">
          <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
          </g>
          <defs>
          <clipPath id="clip0_3430_9566">
          <rect width="206" height="62" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          <div class="relative z-1">3d Animation</div>
        </div>
      </NuxtLink>

      <NuxtLink :to="{name: 'works', query: {q: '3d-anamorphic'}}" class="absolute z-10 top-1/2 left-1/2 rotate-[20deg] translate-y-[150%] translate-x-[100%] uppercase rounded-full" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
        <div class="relative text-white text-[1.5vw] w-fit px-6 py-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-purple -scale-x-[1.3] -scale-y-[1.1]" viewBox="0 0 206 62" fill="none">
          <g clip-path="url(#clip0_3430_9566)">
          <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
          </g>
          <defs>
          <clipPath id="clip0_3430_9566">
          <rect width="206" height="62" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          <div class="relative z-1">3d Anamorphic</div>
        </div>
      </NuxtLink>

      <NuxtLink :to="{name: 'works', query: {q: 'explainer-video'}}" class="absolute top-1/2 left-1/2 -rotate-[20deg] translate-y-[400%] -translate-x-[70%] uppercase rounded-full" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
        <div class="relative text-white text-[1.5vw] w-fit px-6 py-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-orange scale-x-[1.3] -scale-y-[1.1]" viewBox="0 0 206 62" fill="none">
          <g clip-path="url(#clip0_3430_9566)">
          <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
          </g>
          <defs>
          <clipPath id="clip0_3430_9566">
          <rect width="206" height="62" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          <div class="relative z-1">Explainer Video</div>
        </div>
      </NuxtLink>
      
    </div>
  </div>

  
</template>

<script setup>
const mainStore = useMainStore();
const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};
</script>